import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from '../Services/translation';

window.onKlarnaSignIn = async function(klarnaResponse) {
    try {
        const response = await fetch('/api/klarna/klarnaLogin', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'litium-request-context': JSON.stringify(window.__litium.requestContext),
            },
            body: JSON.stringify({ klarnaResponse }),
        });
        if (response.ok) {
            const loginStatus = await response.json();
            const redirectUrl = loginStatus.redirectUrl
            if (redirectUrl !== "") {
                redirectTimeout = setTimeout(() => {
                    window.location.href = redirectUrl;
                }, 1000);
            }
        } else {
            // Handle errors here
        }
    } catch (error) {
        // Handle network errors or other exceptions here
    }
}

window.onKlarnaSignInError = (response) => {
    const respone = respone;
    console.log("response: ", response)
    ReactDOM.render(
        <p className="sign-in-error">{translate('login.klarna.error')}</p>,
        document.getElementById('error-container')
    );
}